<template>
    <date-time-field
        :rules-prop="[isRequired ? rules.required : rules.alwaysValid]"
        :disabled="isDisabled"
        :value="dateTime"
        @update:display-day="displayCustomDay = $event"
        @update:display-hour="displayCustomHour = $event"
        @update:display-minute="displayCustomMinute = $event"
        @input="$emit('input', id, displayCustomDay + 'T' + displayCustomHour + ':' + displayCustomMinute)"
    />
</template>

<script lang="ts">
import { mixins } from 'vue-class-component';
import { Vue, Component, Prop } from 'vue-property-decorator';
import DateTimeField from './DateTimeField.vue';
import type { TemplateCustomizeField } from '../../store/modules/application_form_template/types';
import InputValidation from '../../mixins/InputValidation';

@Component({
    name: 'CustomizedFieldDateAndTime',
    components: {
        DateTimeField,
    },
})
export default class CustomizedFieldDateAndTime extends mixins(InputValidation) {
    @Prop({ default: undefined }) readonly field: TemplateCustomizeField;
    @Prop({ default: undefined }) readonly value: Date | undefined;
    @Prop({ default: false }) readonly disabled: boolean;

    displayCustomDay?: string = '';
    displayCustomHour?: string = '';
    displayCustomMinute?: string = '';

    /**
     * getters
     */
    get isRequired(): boolean {
        return this.field.required;
    }

    get isDisabled(): boolean {
        return this.disabled;
    }

    get dateTime(): Date | undefined {
        return this.value;
    }

    get id(): number {
        return this.field.id;
    }
}
</script>
